import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFolderTag } from 'api/folders';
import { getTags } from 'api/tags';
import { useParams } from 'react-router-dom';
import Popup from 'components/Popup';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';

export default function FolderAddTagPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { folderId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateOffice'],
        mutationFn: createFolderTag,
        onSuccess: () => {
            cache.invalidateQueries(['folders', folderId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating folder-tag:", error);
        }
    });

    const { data: elements } = useQuery({
        queryKey: ['tags'],
        queryFn: async () => await getTags({}),
    });


    const selectOptions = elements?.map(element => {
        return {
            value: element._id,
            label: element.name
        }
    });


    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: folderId,
            data: {
                tag: e.target.tag.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler}>
                {selectOptions &&
                    <SelectInput
                        name="tag"
                        label="Tag"
                        required
                        options={selectOptions?.filter(element => !present.includes(element.value))}
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
